// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2QGPB","title":"AfterImages45_title__3mOSc","images":"AfterImages45_images__2ijuU"};